import { ReactNode } from 'react'
import Link from 'next/link'
import { VERSION_NUMBER } from '../../config'
import CustomText from '../base/CustomText'
import SEO from './SEO'

type Props = {
  children?: ReactNode
  title?: string
}

const CenterLayout = ({ children, title }: Props): JSX.Element => {
  return (
    <div>
      <SEO title={title} />
      <div className="w-full h-12 sm:h-40 bg-secondary" />
      <div className="relative">
        <div className="absolute top-0 left-0 w-full h-20 bg-secondary z-10" />
        <div className="flex flex-col justify-center relative z-20 space-y-4">
          <div>{children}</div>

          <Link href="/changelog">
            <a target="_blank">
              <CustomText size="tiny" weight={400} className="text-center text-gray-dark hover:underline">
                SIMAP V{VERSION_NUMBER}
              </CustomText>
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default CenterLayout
